<template>
  <section
    class="lp-hero relative overflow-hidden min-h-[78vh] flex items-center"
    :style="wrapperStyle"
  >
    <div
      v-if="section.content.backgroundImage"
      class="absolute inset-0 bg-cover bg-center scale-105"
      :style="{ backgroundImage: `url(${section.content.backgroundImage})` }"
    />
    <div
      class="absolute inset-0"
      :style="overlayStyle"
    />
    <div class="lp-hero__glow" aria-hidden="true" />

    <div class="relative w-full max-w-5xl mx-auto px-5 sm:px-8 py-20 sm:py-28 text-center">
      <h1
        v-if="section.content.headline"
        class="lp-hero__headline ps-animate-in"
        :style="{ color: section.styles.headlineColor || '#ffffff' }"
      >
        {{ section.content.headline }}
      </h1>
      <p
        v-if="section.content.subheadline"
        class="lp-hero__sub ps-animate-in"
        :style="{ color: section.styles.subheadlineColor || '#b7c9c4', animationDelay: '0.08s' }"
      >
        {{ section.content.subheadline }}
      </p>
      <div
        v-if="section.content.ctaText || section.content.secondaryCtaText"
        class="mt-10 flex flex-wrap items-center justify-center gap-3 ps-animate-in"
        :style="{ animationDelay: '0.16s' }"
      >
        <a
          v-if="section.content.ctaText"
          :href="section.content.ctaLink || '#'"
          class="lp-hero__cta"
          :style="{ backgroundColor: 'var(--lp-primary-color, #0f766e)' }"
        >
          {{ section.content.ctaText }}
        </a>
        <a
          v-if="section.content.secondaryCtaText"
          :href="section.content.secondaryCtaLink || '#'"
          class="lp-hero__cta lp-hero__cta--ghost"
          :style="secondaryCtaStyle"
        >
          {{ section.content.secondaryCtaText }}
        </a>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  props: {
    section: { type: Object, required: true },
    preview: { type: Boolean, default: false },
  },
  computed: {
    wrapperStyle() {
      return {
        backgroundColor: this.section.styles.backgroundColor || '#0b1f1c',
        textAlign: this.section.styles.textAlign || 'center',
      }
    },
    overlayStyle() {
      if (!this.section.content.backgroundImage) {
        return {
          background:
            'radial-gradient(ellipse 70% 55% at 50% 20%, color-mix(in srgb, var(--lp-primary-color, #0f766e) 28%, transparent), transparent 65%)',
        }
      }
      return {
        backgroundColor: this.section.styles.overlayColor || 'rgba(8, 20, 18, 0.62)',
      }
    },
    secondaryCtaStyle() {
      const color = this.section.styles.headlineColor || '#ffffff'
      return {
        borderColor: color,
        color,
      }
    },
  },
}
</script>

<style scoped>
.lp-hero__glow {
  position: absolute;
  inset: auto 10% -20% 10%;
  height: 40%;
  background: radial-gradient(ellipse at center, color-mix(in srgb, var(--lp-primary-color, #0f766e) 35%, transparent), transparent 70%);
  pointer-events: none;
}

.lp-hero__headline {
  font-family: var(--ps-font-display);
  font-size: clamp(2.4rem, 6vw, 4.25rem);
  font-weight: 700;
  letter-spacing: -0.045em;
  line-height: 1.05;
  max-width: 16ch;
  margin: 0 auto 1rem;
}

.lp-hero__sub {
  font-size: clamp(1.05rem, 2vw, 1.3rem);
  line-height: 1.55;
  max-width: 36rem;
  margin: 0 auto;
  opacity: 0.95;
}

.lp-hero__cta {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0.95rem 1.6rem;
  border-radius: 0.85rem;
  font-weight: 700;
  color: #fff;
  text-decoration: none;
  transition: transform 0.18s ease, box-shadow 0.18s ease, opacity 0.18s ease;
  box-shadow: 0 16px 30px -18px color-mix(in srgb, var(--lp-primary-color, #0f766e) 90%, #000);
}

.lp-hero__cta:hover {
  transform: translateY(-2px);
  opacity: 0.95;
}

.lp-hero__cta--ghost {
  background: transparent;
  border: 1.5px solid;
  box-shadow: none;
}
</style>
